const updates = [
  {
    date: '2026.07.31',
    title: '《长安十二时辰之风起云涌》第 24 集更新',
    desc: '本季大结局倒计时！李必与张小敬联手破解最后谜团，剧情迎来最高潮。',
    tag: '热播更新',
  },
  {
    date: '2026.07.30',
    title: '《暗夜追光》全剧 24 集一次性上线',
    desc: '豆瓣开分 9.0，年度口碑黑马。犯罪悬疑爱好者不可错过的神作。',
    tag: '全集上线',
  },
  {
    date: '2026.07.29',
    title: '韩剧《逆流时光》中字同步首播',
    desc: '奇幻爱情题材重磅来袭，韩国收视率同时段第一，中文字幕同步更新。',
    tag: '新剧上线',
  },
  {
    date: '2026.07.28',
    title: '《锦瑟年华》播放量突破 10 亿',
    desc: '成为红桃影院年度第三部破 10 亿的现象级剧集，口碑持续发酵。',
    tag: '里程碑',
  },
  {
    date: '2026.07.27',
    title: '古装专区新增 12 部经典老剧',
    desc: '包括《琅琊榜》《甄嬛传》《庆余年》等经典古装大剧，高清修复版上线。',
    tag: '片库扩充',
  },
  {
    date: '2026.07.26',
    title: '播放器全面升级，支持 4K 超清画质',
    desc: '技术团队完成播放器重大更新，部分剧集已支持 4K 分辨率，沉浸感拉满。',
    tag: '功能更新',
  },
  {
    date: '2026.07.25',
    title: '暑期追剧专题「夏日剧场」正式上线',
    desc: '精心策划暑期片单，涵盖甜宠、悬疑、古装三大主题，陪你度过炎炎夏日。',
    tag: '专题活动',
  },
  {
    date: '2026.07.24',
    title: '《星河万里》开播首周即登热播榜前十',
    desc: '航天职场题材新颖独特，年轻观众好评如潮，被誉为「年度最燃职场剧」。',
    tag: '新剧热播',
  },
];

export default function UpdatesSection() {
  return (
    <section id="updates" className="py-14 md:py-18 bg-background-100">
      <div className="max-w-[860px] mx-auto px-4 md:px-6">
        <div className="text-center mb-8">
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950 mb-2">最新动态</h2>
          <p className="text-sm text-foreground-500">红桃影院的每一次更新，都与你有关</p>
        </div>
        <div className="relative">
          <div className="absolute left-[19px] top-2 bottom-2 w-px bg-background-300"></div>
          <div className="space-y-5">
            {updates.map((item, idx) => (
              <div key={idx} className="relative flex gap-5">
                <div className="relative z-10 w-[38px] h-[38px] flex-shrink-0 flex items-center justify-center rounded-full bg-background-50 border-2 border-background-300">
                  <div className="w-2.5 h-2.5 rounded-full bg-primary-500"></div>
                </div>
                <div className="flex-1 bg-background-50 rounded-xl p-4 md:p-5 border border-background-200/60">
                  <div className="flex items-center gap-2 mb-2">
                    <span className="text-xs text-foreground-400">{item.date}</span>
                    <span className="px-2 py-0.5 rounded text-xs font-medium bg-accent-100 text-accent-700 whitespace-nowrap">
                      {item.tag}
                    </span>
                  </div>
                  <h3 className="font-heading text-sm md:text-base font-bold text-foreground-950 mb-1">
                    {item.title}
                  </h3>
                  <p className="text-xs md:text-sm text-foreground-600 leading-relaxed">
                    {item.desc}
                  </p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}